exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-height[data-v-6acac0c3]{height:calc(100% - 95px)}.detail-height[data-v-6acac0c3]{height:calc(100% - 50px)}[data-v-6acac0c3].detail_table .el-input-group__append,[data-v-6acac0c3].detail_table .el-input__icon{display:none}[data-v-6acac0c3].detail_table input{border:0;background:transparent!important}[data-v-6acac0c3].detail_table .el-date-editor{border:0;background:transparent}[data-v-6acac0c3].detail_table .el-range-separator{background:transparent}[data-v-6acac0c3].detail_table input[disabled]{color:var(--titleTextColor);padding:0!important}[data-v-6acac0c3].detail_table .el-form-item{margin:0!important}", ""]);

// exports
